import React from 'react'
import MenuStoryMode from '../components/MenuStoryMode';

const GAME_STORY_MODE = () => {
    return (
        <div>
            {/* Story mode components go here */}
            <MenuStoryMode/>  
        </div>
    )
};

export default GAME_STORY_MODE;
